import React, { useState } from 'react';
import { Navigate, Outlet, Link, useLocation, useNavigate } from 'react-router-dom';

const AdminLayout = () => {
  const isLoggedIn = localStorage.getItem('isAdminLoggedIn') === 'true';
  const location = useLocation();
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  if (!isLoggedIn) {
    return <Navigate to="/admin/login" replace />;
  }

  const handleSignOut = () => {
    localStorage.removeItem('isAdminLoggedIn');
    navigate('/admin/login');
  };

  const navItems = [
    { name: 'Dashboard', path: '/admin', icon: 'space_dashboard' },
    { name: 'Projects', path: '/admin/projects', icon: 'domain' },
    { name: 'Files', path: '/admin/files', icon: 'folder' },
    { name: 'Contact', path: '/admin/contact', icon: 'contact_page' },
    { name: 'Requests', path: '/admin/requests', icon: 'tactic' },
    { name: 'Gallery', path: '/admin/gallery', icon: 'collections' },
    { name: 'Testimonials', path: '/admin/testimonials', icon: 'star_rate' },
    { name: 'Blog', path: '/admin/blog', icon: 'article' },
    { name: 'FAQ', path: '/admin/faq', icon: 'quiz' },
    { name: 'Careers', path: '/admin/careers', icon: 'work' },
  ];

  return (
    <div className="min-h-screen bg-[#131313] flex">
      {/* SideNavBar - Desktop & Mobile */}
      {isMobileMenuOpen && (
        <div className="fixed inset-0 bg-black/50 z-40 md:hidden" onClick={() => setIsMobileMenuOpen(false)}></div>
      )}
      <aside className={`${isMobileMenuOpen ? 'flex' : 'hidden'} md:flex flex-col h-screen fixed md:sticky top-0 left-0 w-[280px] bg-[#1c1b1b] border-r border-white/10 shadow-2xl py-8 z-50 transition-transform`}>
        <div className="px-6 mb-12 flex justify-between items-start">
          <div>
            <h1 className="font-bold text-2xl text-[#f59e0b]" style={{ fontFamily: 'Bebas Neue' }}>Management Console</h1>
            <p className="text-[#a08e7a] text-sm">Elite Portfolio Access</p>
          </div>
          <button className="md:hidden text-white" onClick={() => setIsMobileMenuOpen(false)}>
            <span className="material-symbols-outlined">close</span>
          </button>
        </div>
        <nav className="flex-1 px-4 space-y-2 overflow-y-auto">
          {navItems.map((item) => {
            const isActive = location.pathname === item.path || (item.path !== '/admin' && location.pathname.startsWith(item.path));
            return (
              <Link 
                key={item.name}
                to={item.path} 
                onClick={() => setIsMobileMenuOpen(false)}
                className={`flex items-center gap-4 px-4 py-3 rounded text-sm uppercase tracking-widest transition-all duration-300 group cursor-pointer active:scale-95 ${isActive ? 'text-[#f59e0b] border-r-2 border-[#f59e0b] bg-[#f59e0b]/10 font-bold' : 'text-[#a08e7a] hover:text-white hover:bg-white/5'}`}
              >
                <span className="material-symbols-outlined font-light group-hover:translate-x-1 transition-transform">{item.icon}</span>
                <span className="group-hover:translate-x-1 transition-transform">{item.name}</span>
              </Link>
            );
          })}
        </nav>
        <div className="px-4 mt-auto pt-8">
          <button onClick={handleSignOut} className="w-full flex items-center gap-4 px-4 py-3 rounded text-[#d8c3ad] hover:text-[#ffb4ab] hover:bg-white/5 transition-all duration-300 group cursor-pointer active:scale-95 border-t border-white/5 text-sm uppercase tracking-widest">
            <span className="material-symbols-outlined font-light group-hover:translate-x-1 transition-transform">logout</span>
            <span className="group-hover:translate-x-1 transition-transform">Log Out</span>
          </button>
        </div>
      </aside>

      {/* Main Content Area */}
      <main className="flex-1 flex flex-col min-h-screen relative w-full overflow-x-hidden bg-[#131313]">
        {/* TopNavBar */}
        <header className="w-full h-16 sticky top-0 bg-[#131313]/80 backdrop-blur-xl border-b border-white/10 shadow-sm flex justify-between items-center px-4 md:px-8 z-30">
          <button 
            className="md:hidden text-[#f59e0b] p-2 hover:bg-white/5 rounded-full transition-colors cursor-pointer active:scale-95"
            onClick={() => setIsMobileMenuOpen(true)}
          >
            <span className="material-symbols-outlined">menu</span>
          </button>
          <div className="flex-1 flex items-center ml-2 md:ml-0">
            <span className="font-bold text-xl tracking-tighter text-[#f59e0b]" style={{ fontFamily: 'Bebas Neue' }}>HBB0011 REALTY</span>
          </div>
          <div className="flex items-center gap-4">
            <div className="w-8 h-8 rounded-full bg-[#353534] border border-white/10 overflow-hidden flex items-center justify-center text-white font-bold">
              A
            </div>
          </div>
        </header>

        {/* Page Content */}
        <div className="flex-1 relative">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default AdminLayout;
